import React, { createContext, useContext } from 'react'

// Django for Beginners: Build Websites with Python and Django
const AFFILIATE_LINK_DJANGO_FOR_BEGINNERS = '//ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=1735467200&asins=1735467200&linkId=3f8232c24b2dd1690f154e1fbe8cb9b3&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'
// Django for Professionals: Production websites with Python & Django
const AFFILIATE_LINK_DJANGO_FOR_PROFESSIONALS = '//ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=1735467200&asins=1735467200&linkId=bd8590ea734d8c76e38cd28d384a2956&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'
// Two Scoops of Django 1.11: Best Practices for the Django Web Framework
const AFFILIATE_LINK_TWO_SCOOPS_OF_DJANGO = '//ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=0692915729&asins=0692915729&linkId=ae70b2d5ff5e025c6f1dc00a55e024f4&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'
// Working Effectively with Legacy Code
const AFFILIATE_LINK_WORKING_EFFECTIVELY_WITH_LEGACY_CODE = '//ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=0131177052&asins=0131177052&linkId=8ae7083394de935e9e4bcebf9bc80f77&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'
// Learn Python the Hard Way (3rd Edition)
const AFFILIATE_LINK_LEARN_PYTHON_HARD_WAY = 'http://ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=0134692888&asins=0134692888&linkId=400454948ab2b2ded4502f706d1ce73b&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'
// Python for Data Analysis, 2e: Data Wrangling with Pandas, Numpy, and Ipython
const AFFILIATE_LINK_PYTHON_FOR_DATA_ANALYSIS = '//ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=1491957662&asins=1491957662&linkId=e8c32100b187a4ac0626e827254e7384&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'
// Bad Data Handbook: Cleaning Up The Data So You Can Get Back To Work
const AFFILIATE_LINK_BAD_DATA_HANDBOOK = '//ws-eu.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=GB&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=codereviewdoc-21&marketplace=amazon&amp;region=GB&placement=1449321887&asins=1449321887&linkId=ab9b96c1ad2c80234208c54a2c0b9cb1&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff'


export const useProduct = () => useContext(ProductContext)

const django = {
  id: 'djangodoctor',
  name: 'Code Review Doctor',
  stack: 'Django',
  gitHubMarketplaceLink: 'https://github.com/marketplace/django-doctor/',
  checkCount: 40,
  domain: 'codereview.doctor',
  socialLinkDevDotTo: 'https://dev.to/codereviewdoctor',
  socialLinkTwitter: "https://twitter.com/CodeReviewDr",
  socialLinkFacebook: "https://www.facebook.com/CodeReviewDoctor",
  socialLinkLinkedIn: "https://www.linkedin.com/company/code-review-doctor",
  affiliateLinks: [
    AFFILIATE_LINK_DJANGO_FOR_BEGINNERS,
    AFFILIATE_LINK_DJANGO_FOR_PROFESSIONALS,
    AFFILIATE_LINK_TWO_SCOOPS_OF_DJANGO,
    AFFILIATE_LINK_WORKING_EFFECTIVELY_WITH_LEGACY_CODE,
  ]
}

const python = {
  id: 'python',
  name: 'Code Review Doctor',
  stack: 'Python',
  gitHubMarketplaceLink: 'https://github.com/marketplace/django-doctor/',
  checkCount: 30,
  domain: 'codereview.doctor',
  socialLinkDevDotTo: 'https://dev.to/codereviewdoctor',
  socialLinkTwitter: "https://twitter.com/CodeReviewDr",
  socialLinkFacebook: "https://www.facebook.com/CodeReviewDoctor",
  socialLinkLinkedIn: "https://www.linkedin.com/company/code-review-doctor",
  affiliateLinks: [
    AFFILIATE_LINK_LEARN_PYTHON_HARD_WAY,
    AFFILIATE_LINK_PYTHON_FOR_DATA_ANALYSIS,
    AFFILIATE_LINK_WORKING_EFFECTIVELY_WITH_LEGACY_CODE,
    AFFILIATE_LINK_BAD_DATA_HANDBOOK,
  ]
}

const all = {
  id: 'codereviewdoctor',
  name: 'Code Review Doctor',
  stack: 'Python',
  gitHubMarketplaceLink: 'https://github.com/marketplace/django-doctor/',
  checkCount: 70,
  domain: 'codereview.doctor',
  socialLinkDevDotTo: 'https://dev.to/codereviewdoctor',
  socialLinkTwitter: "https://twitter.com/CodeReviewDr",
  socialLinkFacebook: "https://www.facebook.com/CodeReviewDoctor",
  socialLinkLinkedIn: "https://www.linkedin.com/company/code-review-doctor",
}

const mapping = {
  django,
  python,
  all,
}

export const ProductProvider = ({name, children}) => {
  const value = mapping[name]
  return (
    <ProductContext.Provider value={value}>
      {children}
    </ProductContext.Provider>
  )
}

export const ProductContext = createContext({})
